import { render } from "./DisplayCurrencySelectorField.vue?vue&type=template&id=764698aa"
import script from "./DisplayCurrencySelectorField.vue?vue&type=script&lang=js"
export * from "./DisplayCurrencySelectorField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__